import type { AnalyzedPage } from '../types';

/** Shows which pages fed the brand analysis (multi-page context). */
export default function AnalyzedPages({ pages }: { pages: AnalyzedPage[] }): JSX.Element | null {
  if (!pages.length) return null;
  return (
    <div className="mb-3 font-mono text-sm text-text-secondary">
      <span className="uppercase tracking-widest">Analysed {pages.length} pages: </span>
      {pages.map((p, i) => (
        <span key={p.url}>
          <a href={p.url} target="_blank" rel="noreferrer" className="hover:text-cyan transition">
            {new URL(p.url).pathname === '/' ? 'home' : new URL(p.url).pathname.replace(/\/$/, '')}
          </a>
          {i < pages.length - 1 ? ' · ' : ''}
        </span>
      ))}
    </div>
  );
}
